import $ from 'jquery';
import SubscriptionService from '../_shared/subscription-service';
import AccountService from '../_shared/account-service';
import ProductEvents from '../gtm/product-events';
import BaseEvent from '../gtm/base-event';

export default class PremiumVideo {
  constructor() {
    this.$premiumContent = $('.js-premium-player-wrapper');
    this.$signInRequired = $('.js-sign-in-required');
    this.premiumPlayerId = 'js-premium-player';
    this.$proceedToSubscriebBtn = $('.js-proceed-to-subscribe');
    this.$progressOverlay = $('.js-progress-overlay');
    this.$playerOverlap = $('.player-overlap--signin, .player-overlap--premium');

    this.gtmProductEvents = new ProductEvents('ott', '9c1b4533-9165-4c4a-a8e9-85a4bd70b8e1');
    this.gtmBaseEvent = new BaseEvent();

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$signInRequired.length && !this.$premiumContent.length) {
      this.isInitialized = false;

      return;
    }

    this.setProductEvents();

    const isAuthenticated = await AccountService.isAuthenticated();

    if (!isAuthenticated) {
      this.$progressOverlay.hide();
      return;
    }

    this.getVideoRefernceAndInit();
  }

  getVideoRefernceAndInit() {
    this.$premiumContent.each(async (_, element) => {
      const videoId = $(element).data('video-id');
      const pageId = $(element).data('page-id');
      const lang = $(element).data('lang');

      const $signInRequired = $(element).find(this.$signInRequired);
      const { videoReference } = await SubscriptionService.fetchVideoDetails(videoId, pageId, lang, $signInRequired.length) || {};

      if (!videoReference) {
        $(element).addClass('not-eligible');
        $(element).find(this.$progressOverlay).hide();
        $(element).find('.js-proceed-to-subscribe').each((__, btn) => {
          $(btn).attr('href', $(btn).data('subscription-href'));
        });
      }

      $(element).find(this.$signInRequired).removeClass('signed-out');
      $(element).find(this.$signInRequired).addClass('signed-in');

      PremiumVideo.initPlayer(videoReference, `${this.premiumPlayerId}-${videoId}`, $(element), this.$progressOverlay);
    });
  }

  setProductEvents() {
    if (!this.$signInRequired.length && this.$premiumContent.length) {
      this.$proceedToSubscriebBtn.each((_, element) => {
        this.gtmProductEvents.promoImpressionEvent(element);
        $(element).on('click', (e) => {
          e.preventDefault();
          this.gtmProductEvents.promoClickEvent(e.currentTarget);
        });
      });
    }
  }

  static initPlayer(videoId, playerId, $premiumContentContainer, $progressOverlay) {
    try {
      const playerInstance = window.videojs.getPlayer(playerId);
      if (!playerInstance) {
        $progressOverlay.hide();
        console.log(`Could not get player instance:: videoId: ${videoId}, playerId: ${playerId}`);
        return;
      }
      playerInstance.ready(function onPlayerReady() {
        const player = this;

        player.catalog.getVideo(videoId, (error, video) => {
          if (error) {
            $progressOverlay.hide();
            console.error('An error occured while getting video: ', error);
            return;
          }

          player.catalog.load(video);
          $premiumContentContainer.addClass('is-eligible');
          $progressOverlay.hide();
        });

        player.on('error', () => {
          $progressOverlay.hide();
          const err = player.error();
          console.error('Playback Error Code:', err.code, 'Message:', err.message);
        });
      });
    } catch (e) {
      $progressOverlay.hide();
      console.error('Error: Could not initialize premium video player', e);
    }
  }
}
